
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/token-transfers",
      function () {
        return require("private-next-pages/token-transfers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/token-transfers"])
      });
    }
  